'use es6';

import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import createReactClass from 'create-react-class';
import { connect } from 'react-redux';
import { List } from 'immutable';
import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIViewController from 'UIComponents/input/UIViewController';
import H5 from 'UIComponents/elements/headings/H5';
import { ONE_HOUR } from 'MeetingsBase/constants/dates';
import { getCustomParams as getCustomParamsSelector, getEvent as getEventSelector } from 'MeetingsLib/selectors/BookInfoSelectors';
import { setEventDuration } from 'MeetingsLib/redux/actions/FormActions';
import { HiddenAriaStatus } from 'MeetingsLib/components/decorative/HiddenAriaStatus';
import { getAvailableStartTimesForSelectedDate as getAvailableStartTimesForSelectedDateSelector } from 'MeetingsLib/selectors/AvailabilitySelectors';
var DurationPicker = createReactClass({
  displayName: "DurationPicker",
  propTypes: {
    // loaded
    durationOptions: PropTypes.instanceOf(List).isRequired,
    selectedDuration: PropTypes.number.isRequired,
    selectedDate: PropTypes.string,
    setEventDuration: PropTypes.func.isRequired,
    availableStartTimeOptions: PropTypes.instanceOf(List).isRequired
  },
  getInitialState: function getInitialState() {
    return {
      tabIndex: -1
    };
  },
  componentDidUpdate: function componentDidUpdate(nextProps) {
    if (nextProps.selectedDate !== this.props.selectedDate) {
      this.setState({
        tabIndex: 0
      });
      var durationPicker = document.getElementById('duration-select');

      if (durationPicker) {
        durationPicker.focus();
      }
    }
  },
  handleSetEventDuration: function handleSetEventDuration(_ref) {
    var value = _ref.target.value;
    this.props.setEventDuration(value);
    this.setState({
      tabIndex: -1
    });
  },
  getCompoundTime: function getCompoundTime(hours, minutes) {
    var hourString = I18n.text('prebook.durationPicker.shortHourCount', {
      count: Math.floor(hours)
    });
    var minuteString = I18n.text('prebook.durationPicker.minuteCount', {
      count: minutes
    });
    return I18n.text('prebook.durationPicker.combination', {
      hours: hourString,
      minutes: minuteString
    });
  },
  getHours: function getHours(hours) {
    return I18n.text('prebook.durationPicker.hourCount', {
      count: hours
    });
  },
  getMinutes: function getMinutes(minutes) {
    return I18n.text('prebook.durationPicker.minuteCount', {
      count: minutes
    });
  },
  getDurationOptionText: function getDurationOptionText(duration) {
    var minutes = I18n.moment.duration(duration).asMinutes();

    if (duration >= ONE_HOUR) {
      var remainderMinutes = I18n.moment.duration(minutes % 60).valueOf();
      var hours = I18n.moment.duration(duration).asHours();

      if (remainderMinutes !== 0) {
        return this.getCompoundTime(hours, remainderMinutes);
      } else {
        return this.getHours(hours);
      }
    }

    return this.getMinutes(minutes);
  },
  getButtonGroupOptions: function getButtonGroupOptions(durationOptions) {
    var _this = this;

    return durationOptions.map(function (duration) {
      return {
        text: _this.getDurationOptionText(duration),
        value: duration
      };
    }).toJS();
  },
  renderDurationPickerHeader: function renderDurationPickerHeader(durationOptions) {
    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: "prebook.durationPicker.header",
      options: {
        count: durationOptions.size
      }
    });
  },
  renderDurationPicker: function renderDurationPicker(durationOptions) {
    var buttonGroupOptions = this.getButtonGroupOptions(durationOptions);
    var classes = 'duration-picker p-top-8 p-x-8 width-100' + (durationOptions.size === 1 ? " single" : "");
    return /*#__PURE__*/_jsxs("div", {
      className: classes,
      children: [/*#__PURE__*/_jsx(H5, {
        id: "meeting-duration",
        children: this.renderDurationPickerHeader(durationOptions)
      }), /*#__PURE__*/_jsx(UIViewController, {
        id: "duration-select",
        tabIndex: this.state.tabIndex,
        "aria-labelledby": "meeting-duration",
        className: "display-block",
        value: this.props.selectedDuration,
        onChange: this.handleSetEventDuration,
        defaultValue: durationOptions.first(),
        options: buttonGroupOptions
      }), /*#__PURE__*/_jsx(HiddenAriaStatus, {
        role: "status",
        "aria-live": "polite",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "accessible.durationStatus",
          options: {
            selectedDuration: this.getDurationOptionText(this.props.selectedDuration),
            selectedDate: I18n.moment(this.props.selectedDate).format('MMMM Do')
          }
        })
      })]
    });
  },
  render: function render() {
    var _this$props = this.props,
        durationOptions = _this$props.durationOptions,
        availableStartTimeOptions = _this$props.availableStartTimeOptions;

    if (!durationOptions || durationOptions.size === 0 || availableStartTimeOptions.count() === 0) {
      return null;
    }

    return this.renderDurationPicker(durationOptions);
  }
});
export default connect(function (state) {
  return {
    // Rerenders component in response to translation
    activeLocale: state.activeLocale,
    selectedDuration: getEventSelector(state).duration,
    selectedDate: getEventSelector(state).dateString,
    durationOptions: getCustomParamsSelector(state).durations,
    availableStartTimeOptions: getAvailableStartTimesForSelectedDateSelector(state)
  };
}, {
  setEventDuration: setEventDuration
})(DurationPicker);